import { GROUPS_TAKING_THE_RIDE } from '@/constants/groups-taking-the-ride';
import { TYPES_OF_SERVICES } from '@/constants/types-of-services';
import { array, object, string } from 'yup';

export const companySizeAndNatureModel = object({
	companySize: string().required('Company size is required'),
	natureOfBusiness: string().required('Nature of Business is required'),
});

export const servicesToProvideModel = object({
	services: array()
		.of(
			string()
				.oneOf(
					TYPES_OF_SERVICES,
					`Invalid value must be one of ${TYPES_OF_SERVICES.join(', ')}`,
				)
				.required('Service is required'),
		)
		.min(1, 'At least one service must be selected')
		.required('Services to provide is required'),
});

export const whoWillRideModel = object({
	riders: array()
		.of(
			string()
				.oneOf(
					GROUPS_TAKING_THE_RIDE,
					`Invalid value must be one of ${GROUPS_TAKING_THE_RIDE.join(', ')}`,
				)
				.required('Group of riders are required'),
		)
		.min(1, 'At least one group must be selected')
		.required('Group of riders are required'),
});

export const serviceEstimatesModel = object({
	rideEstimate: string().required('Estimate is required'),
	ridePurposes: array()
		.of(string().required('Purpose is required'))
		.min(1)
		.required('Purpose is required'),
	// mealsEstimate: string().required('Estimate is required'),
	// mealsPurposes: array().of(string()).min(1).required('Purpose is required'),
	// deliveryEstimate: string().required('Estimate is required'),
	// deliveryPurposes: array()
	// 	.of(string())
	// 	.min(1)
	// 	.required('Purpose is required'),
});

export const estimatedBudgetModel = object({
	estimatedBudget: string().required('Estimate is required'),
	estimatedFrequency: string().required('Estimate is required'),
});
